import { getLocale } from '@/i18n/locale';
import { ELocale } from '@/i18n/localeEnum';
import { getWeskiMappingsSync } from '@/api/weski/static';

const IT_LOCALE_MAPPING = ['1374', '604', '605', '2593'];

export function weSkiDestinationId({ resortId, regionId }: { resortId?: string, regionId?: string }) {
  const maps = getWeskiMappingsSync();
  if (!maps) {
    return null;
  }

  // https://mountainnews.jira.com/browse/OWR-1948
  if (getLocale() === ELocale.IT_IT) {
    if (resortId) {
      if (IT_LOCALE_MAPPING.includes(resortId)) {
        return maps.resort.get(resortId) ?? null;
      }
    }
    return null;
  }
  if (resortId) {
    return maps.resort.get(resortId) ?? null;
  }

  if (regionId) {
    return maps.region.get(regionId) ?? null;
  }
  return null;
}

export function hasWeSkiIntegration({ resortId, regionId }: { resortId?: string, regionId?: string }) {
  return !!weSkiDestinationId({ resortId, regionId });
}
